import { Link } from "react-router-dom";
import { fileUrl } from "../../lib/api";

function publicLink(value, platform) {
  if (typeof value !== "string" || !value.trim()) return null;
  let raw = value.trim();
  if (platform === "instagram" && /^@?[a-zA-Z0-9._]+$/.test(raw) && !raw.includes("instagram.com")) raw = `https://www.instagram.com/${raw.replace(/^@/, "")}/`;
  else if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(raw)) raw = `https://${raw}`;
  try { const url = new URL(raw); return ["http:", "https:"].includes(url.protocol) ? url.href : null; } catch { return null; }
}

export default function ArtistCard({ artist }) {
  if (!artist?.name) return null;
  const portrait = (Array.isArray(artist.portrait) ? artist.portrait[0] : artist.portrait) || artist.images?.[0];
  const biography = artist.short_bio || artist.description;
  const links = [
    ["Website", publicLink(artist.website)],
    ...Object.entries(artist.socials || {}).map(([platform, value]) => [({ instagram: "Instagram", facebook: "Facebook", tiktok: "TikTok", other: "Weiterer Link" })[platform] || platform, publicLink(value, platform)]),
  ].filter(([, href]) => href);
  return (
    <section className="border-2 border-[#121212] bg-[#F4EFEA] p-5 sm:p-6" data-testid="artwork-artist-card">
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0047FF]">Der Mensch hinter dem Werk</p>
      <div className="flex items-start gap-4 mt-4">
        {portrait?.url && <img src={fileUrl(portrait.thumb || portrait.url)} alt={portrait.alt || artist.name} className="w-20 h-20 sm:w-24 sm:h-24 object-cover shrink-0" loading="lazy" />}
        <div className="min-w-0"><h2 className="text-2xl font-black">{artist.name}</h2>
          {biography && <p className="mt-3 text-sm whitespace-pre-line leading-relaxed">{biography}</p>}
          <div className="flex flex-wrap gap-x-5 gap-y-2 mt-4 text-sm font-semibold">
            {artist.slug && <Link to={`/kuenstler/${artist.slug}`} className="underline py-2">Künstlerprofil & weitere Werke →</Link>}
            {links.map(([label, href]) => <a key={href} href={href} target="_blank" rel="noopener noreferrer" className="underline py-2">{label} ↗</a>)}
          </div>
        </div>
      </div>
    </section>
  );
}
